
import { api } from "../api";

/**
 * secretaryFindAllCrudResponse - Function that finds on database all secretaries by customer id as crud response  
 * /secretaries/{customerId}/{status}   
 * method GET 
 * @async-function
 */
const secretaryFindAllCrudResponse = async (token: string, customerId: number, status: string, page: number, size: number) => {
    const response = await api.get(
        `/secretaries/${customerId}/${status}?page=${page}&size=${size}`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
         }
    );
    return response;
};

export default secretaryFindAllCrudResponse;